'use client';

import { Player } from '@/components/react-player';
import { FilePathUtils } from '@/config';
import { fallbackImages } from '@/utils/fallback-images';
import Image from 'next/image';
import { useState } from 'react';

type Props = {
  url: string;
  thumbnail: string;
  courseId: number;
};

function CoursePromo({ url, thumbnail, courseId }: Props) {
  const [isPlaying, setIsPlaying] = useState(false);

  if (!url) {
    return (
      <div className="translate-y-1/2 md:-mt-[18%] -mt-[18%] mb-[17%] lg:w-2/3 mx-auto">
        <Image
          className="object-cover aspect-[1600/960] w-full rounded-lg"
          alt="course image"
          src={
            thumbnail
              ? `${FilePathUtils.courseImagePath(courseId)}/${thumbnail}`
              : fallbackImages.course
          }
          quality={100}
          width={842}
          height={504}
        />
      </div>
    );
  }

  return (
    <div className="translate-y-1/2 md:-mt-[14%] -mt-[18%] mb-[15%] lg:w-2/3 mx-auto">
      <div className="container relative w-full h-auto rounded-sm aspect-video">
        <Player
          url={url || ''}
          playing={isPlaying}
          playIcon={
            <div
              onClick={() => setIsPlaying(!isPlaying)}
              className={`cursor-pointer bg-opacity-50 p-2 md:p-3 rounded-full absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 `}
            >
              <Image
                src="/Images/promo-play-icon.png"
                alt="play button"
                className="object-cover"
                width={88}
                height={88}
              />
            </div>
          }
          light={
            <Image
              className="object-cover aspect-[1600/960] w-full rounded-lg"
              alt="course image"
              src={
                thumbnail
                  ? `${FilePathUtils.courseImagePath(courseId)}/${thumbnail}`
                  : fallbackImages.course
              }
              width={842}
              height={504}
            />
          }
          controls
        />
      </div>
    </div>
  );
}

export default CoursePromo;
